import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { ModulesPending } from "../features/modules/ModulesPending";
import { useEnabledModules } from "../features/modules/useEnabledModules";
import { firstAvailablePath } from "./navigation";

// Развилка `/home` (ADR-0083): пока состав модулей неизвестен —
// ожидание или ошибка с повтором, потом переход в первый доступный
// раздел.
export function HomeRedirect(): ReactElement {
  const modules = useEnabledModules();
  if (modules.status !== "ready") {
    return <ModulesPending state={modules} />;
  }
  return <Navigate replace to={firstAvailablePath(modules.isEnabled)} />;
}
